export default "__VITE_ASSET__C1PFxt0f__"